export default "__VITE_ASSET__04c54d5a__"